import { ReactNode, useCallback, useState } from 'react';
import { ControllerToast, ControllerToastSeverity } from '@bymason-private/legacy-pattern-components';
import ToastContext from '../toast-context';

/**
 * A context provider that manages toast state for Runway apps.
 */
export default function ToastProvider({ children }: { children: ReactNode }): JSX.Element {
  const [toastMessage, setToastMessage] = useState('');
  const [toastSeverity, setToastSeverity] = useState<ControllerToastSeverity>();
  const closeToast = useCallback(() => {
    setToastMessage('');
    setToastSeverity(undefined);
  }, []);

  return (
    <ToastContext.Provider
      value={{
        setToastMessage,
        setToastSeverity,
        closeToast,
      }}
    >
      {children}
      <div>
        {!!toastMessage && !!toastSeverity && (
          <ControllerToast message={toastMessage} severity={toastSeverity} onClose={closeToast} />
        )}
      </div>
    </ToastContext.Provider>
  );
}
